// Feature flags for backend readiness (Backend-V1 upgrade)
// Supports both VITE_* (import.meta.env) and REACT_APP_* (process.env) environment variable prefixes

/**
 * Reads a boolean environment variable from multiple sources
 * @param {string[]} keys - Array of environment variable keys to check
 * @param {boolean} defaultValue - Default value if no key is found (default: false)
 * @returns {boolean} The resolved boolean value
 */
function readBoolEnv(keys, defaultValue = false) {
  for (const key of keys) {
    // Check import.meta.env (Vite)
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key] === 'true') {
      return true;
    }
    // Check process.env (Create React App / Node)
    if (typeof process !== 'undefined' && process.env && process.env[key] === 'true') {
      return true;
    }
  }
  return defaultValue;
}

/**
 * USE_REMOTE_USERS flag
 * When enabled, UsersPage fetches employees from Backend-V1 endpoint and operates in read-only mode
 */
const USE_REMOTE_USERS = readBoolEnv(['VITE_USE_REMOTE_USERS', 'REACT_APP_USE_REMOTE_USERS'], false);

/**
 * ENABLE_SERVER_ACTIVITY_LOG flag
 * When enabled, audit logs recorded via recordAudit() are sent to the Backend-V1 server's
 * /activity-log endpoint in addition to being stored locally. This enables centralized 
 * audit logging across multiple CRM instances.
 * Default: true (enabled)
 */
const ENABLE_SERVER_ACTIVITY_LOG = readBoolEnv(['VITE_ENABLE_SERVER_ACTIVITY_LOG', 'REACT_APP_ENABLE_SERVER_ACTIVITY_LOG'], true);

export { USE_REMOTE_USERS, ENABLE_SERVER_ACTIVITY_LOG };
